/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import 'aisztheme/sass/animate.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import format from 'date-fns/format';
import Toolbar from 'loracoms/Toolbar';
import Nvl from 'loracoms/Nvl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import deviceActions from 'loraactions/device';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import { callAPI } from 'lorautils/api';
import DeviceData from '../DeviceData';
import DevicePktsTrend from '../DevicePktsTrend';
import DeviceDropPktsTrend from '../DeviceDropPktsTrend';
import DeviceSNRTrend from '../DeviceSNRTrend';
import DeviceRSSITrend from '../DeviceRSSITrend';


const propTypes = {
  deviceId: React.PropTypes.string.isRequired,
  appId: React.PropTypes.string.isRequired,
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  deviceState: React.PropTypes.object.isRequired,
  appState: React.PropTypes.object.isRequired,
  replaceState: React.PropTypes.func.isRequired,
};

class StatView extends React.Component {

  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.statview');
    this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      statReloading: false,
      statSeries: {
        drops: {
          name: this.intlMsg.msg('series.droppedpackets'),
          data: [],
          yAxisIndex: 0,
        },
        snr: {
          name: 'SNR',
          data: [],
          yAxisIndex: 0,
        },
        rssi: {
          name: 'RSSI',
          data: [],
          yAxisIndex: 0,
        },
        categories: [],
      },
    };
    this.loadStats = this.loadStats.bind(this);
  }

  componentDidMount() {
    this.loadStats();
  }

  componentWillReceiveProps(nextProps) {
    const { deviceState, appState } = nextProps;
    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  loadStats() {
    const { deviceId } = this.props;

    this.setState({ statReloading: true });

    callAPI({
      endpoint: `/lora/nodes/${deviceId}/rxqos?download`,
    }).then((data) => {
      const drops = [];
      const snr = [];
      const rssi = [];
      const slots = [];
      data.list.reverse().forEach((item) => {
        slots.push(format(item.$time, 'MM-DD HH:mm:ss'));
        drops.push(item.drops);
        snr.push(item.lorasnr);
        rssi.push(item.rssi);
      });
      const { statSeries } = this.state;
      statSeries.drops.data = drops;
      statSeries.snr.data = snr;
      statSeries.rssi.data = rssi;
      statSeries.categories = slots;
      this.setState({
        statSeries,
        statReloading: false,
      });
    });
  }

  renderToolbar() {
    const { appId } = this.props;
    const {
      deviceState: {
        data: { name, deveui } = {},
        status,
      },
      appState: {
        data: { name: appName } = {},
        status: appStatus,
      },
    } = this.state;

    const breadcrumb = [{
      content: <FormattedMessage id="application.breadcrumb.application" />,
      onClick: () => this.props.pushState('/application'),
    }, {
      content: <Nvl val={appName} status={appStatus} />,
      onClick: () => this.props.replaceState(`/application/${appId}`),
    }, {
      content: <Nvl val={name || normalizeDevEUI(deveui || '')} status={status} />,
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    const { deviceId } = this.props;
    const { statSeries, statReloading } = this.state;

    return (
      <Grid fluid>
        <Row><Col md={12}>{this.renderToolbar()}</Col></Row>
        <Row>
          <Col md={12}>
            <DevicePktsTrend deviceId={deviceId} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DeviceDropPktsTrend
              series={statSeries}
              onReload={this.loadStats}
              reloading={statReloading}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DeviceSNRTrend
              series={statSeries}
              onReload={this.loadStats}
              reloading={statReloading}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DeviceRSSITrend
              series={statSeries}
              onReload={this.loadStats}
              reloading={statReloading}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DeviceData deviceId={deviceId} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

StatView.propTypes = propTypes;


const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.appId,
  deviceId: ownProps.params.deviceId,
  deviceState: state.device.getDevice,
  appState: state.app.getApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  replaceState: routerActions.replace,
  getRxQOS: deviceActions.getRxQOS,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(StatView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/StatView/index.jsx